import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';
import { UserService } from '../../features/user-management/services/user.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const userService = inject(UserService);
    const token = userService.accessToken();
    const apiUrls = [
        environment.CompanyAPI,
        environment.DataStewardshipAPI,
        environment.UnifiedAPI,
        environment.DeepResearchAPI,
        environment.AskAIAPI,
        environment.XDMCoreAPI
    ];
    if (token && apiUrls.some(api => req.url.includes(api))) {
        const requestWithAuthorization = req.clone({
            headers: req.headers.set(
                'Authorization',
                'Bearer ' + token
            ),
        });
        return next(requestWithAuthorization);
    }
    return next(req);
};
